import { AlertCircle } from 'lucide-react';

const EmptyState = ({ isError = false, icon, title, description, className = '', descriptionClassName = '' }) => {
  const displayIcon = isError ? <AlertCircle className="h-10 w-10" /> : icon;
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-2xl border ${
        isError ? 'border-danger-soft bg-danger-soft/40' : 'border-cream/60 bg-gray-50'
      } px-6 py-12 text-center text-text-secondary ${className}`}
    >
      {displayIcon ? (
        <div
          className={`mb-4 font-light ${
            isError ? 'text-danger' : 'text-info'
          }`}
        >
          {displayIcon}
        </div>
      ) : null}
      {title ? (
        <p
          className={`text-sm ${
            isError ? 'text-danger' : 'text-primary'
          }`}
        >
          {title}
        </p>
      ) : null}
      {description ? (
        <p
          className={`mt-2 text-sm ${
            isError
              ? 'text-danger'
              : descriptionClassName || 'text-text-secondary'
          }`}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
};

export default EmptyState;


